<ng-container *ngIf="inputData != null"style="font-family: 'SolaimanLipi_bold', 'Ubuntu' !important;
    font-size: 100%;">
    <div style="margin-bottom: 0px">
      <div class="d-table">
        <div class="d-table-cell">
          <div class="container">
            <div class="page-title-content">
              <h2 style="color: white;">{{inputData.TitleEn}}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div class="container" style="padding: 10px;"style="font-family: 'SolaimanLipi_bold', 'Ubuntu' !important;
    font-size: 100%;">
      <br>
      <br>
  
      <div class="row">
        <!-- Left Section (Main Content) -->
        <div class="col-md-8">
          <div class="container" style="text-align: center; background-color: white;">
            <div class="gallery-container">
              <div class="row">
                <ng-container *ngFor="let item of inputData.ShowAttachments">
                  <div class="col-lg-12 col-md-4 col-sm-12" style=" margin-top:20px">
                    <div class="single-team-box">
                      <div class="image">
                        <img [src]="item.FilePath" style="height: 300px;">
                      </div>
                      <div class="content" *ngIf="item.Title != ''">
                        <h4>{{item.Title}}</h4>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
  
              <div class="row">
                <div class="col-md-12">
                  <p style="padding-bottom: 10px;">
                    <span style="text-align: justify !important;font-size: large;" [innerHTML]="inputData.DetailsEn">
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <!-- Right Section (Aside Content) -->
        <div class="col-md-4">
          <app-aside></app-aside>
        </div>
      </div>
    </div>
  </ng-container>
  